import React from 'react';
import ModalBody, { type ModalBodyProps } from '../ModalBody';
import s from './ModalFormBody.scss';

export interface Props extends ModalBodyProps {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const ModalFormBody: React.FC<Props> = ({ children, onSubmit, ...rest }) => {
  return (
    <ModalBody {...rest}>
      <form
        className={s['form']}
        /**
         * Forms add their fields to the url's search string by default. We usually handle this type of submission via
         * redux without a page load, so we don't need those params in the search string. This empty `action` attribute
         * prevents that.
         */
        action=""
        onSubmit={onSubmit}
      >
        {children}
      </form>
    </ModalBody>
  );
};

ModalFormBody.displayName = 'ModalFormBody';

export default ModalFormBody;
